module.exports = __webpack_public_path__ + "img/Hubei-power.14be6753.png";